import React from "react";
import "./MatchList.css";
import { Link } from "react-router-dom";
import img3 from "../../../assets/jsk/jsk1.jpg";

const MatchList = () => {
  return (
    <>
      <div className="match-table container-fluid px-0">
        <div className="">
          {/* Banner Section */}
          <div className="w-full overflow-hidden">
            <img
              src={img3}
              alt="Universe Casino Banner"
              className=""
              style={{ height: "200px", width: "100%", objectFit: "cover", display: "block" }}
              onError={(e) => {
                e.target.style.display = "none";
              }}
            />
          </div>
        </div>

        {/* Title Bar */}
        <div
          className="text-white font-semibold p-2 text-lg shadow-md"
          style={{
            background:
              "linear-gradient(to bottom, rgb(206 48 48), rgb(56 4 4))",
          }}
        >
          Highlights
        </div>
        {/* Header Row */}
        <div className="row match-header mt-0 py-1 align-items-center fw-bold p-1">
          <div className="col-5  fw-bold">Match</div>
          <div className="col-2 text-center fw-bold hides">1</div>
          <div className="col-2 text-center fw-bold hides">X</div>
          <div className="col-2 text-center fw-bold hides">2</div>
        </div>

        {/* Match Rows */}
        {matches.map((m, i) => (
          <Link
            to={`${m.link}`}
            key={i}
            className="text-decoration-none text-light"
          >
            <div className="row match-row align-items-center ">
              <div className="col-5">
                <div className="match-info">
                  <span className="match-name1">{m.name}</span>

                  <small className="match-time text-warning">{m.time}</small>

                  <div className="icons">
                    {m.icons.includes("F") && <span className="icon f">F</span>}
                    {m.icons.includes("S") && <span className="icon s">S</span>}
                    {m.icons.includes("BM") && (
                      <span className="icon bm">BM</span>
                    )}
                  </div>
                </div>
              </div>

              <div className="col-7 d-none d-md-block">
                <div className="odds-wrapper ">
                  <div className="pair">
                    <div className="odd-box blue">{m.odds1[0]}</div>
                    <div className="odd-box pink">{m.odds1[1]}</div>
                  </div>

                  <div className="pair">
                    <div className="odd-box blue">{m.oddsX[0]}</div>
                    <div className="odd-box pink">{m.oddsX[1]}</div>
                  </div>

                  <div className="pair">
                    <div className="odd-box blue">{m.odds2[0]}</div>
                    <div className="odd-box pink">{m.odds2[1]}</div>
                  </div>
                  <div className="pair">
                    <svg
                      _ngcontent-ng-c261849108=""
                      xmlns="http://www.w3.org/2000/svg"
                      width="25"
                      height="25"
                      viewBox="0 0 25 25"
                    >
                      <path
                        _ngcontent-ng-c261849108=""
                        fill="currentColor"
                        d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                      ></path>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </>
  );
};

export default MatchList;
const matches = [
  {
    id: 101,
    name: "BALL BY BALL",
    link: "/cricket/ballbyball",
    time: "In-Play",
    icons: ["F", "S", "BM"],
    odds1: [1.1, 1.11],
    oddsX: [110, 140],
    odds2: [10.5, 11],
  },
  {
    id: 102,
    name: "WBBL – Winner 2025",
    link: "/cricket/wbbl",
    time: "09-11-2025 8:10",
    icons: ["F", "BM"],
    odds1: [2.14, 6],
    oddsX: [2.48, 1000],
    odds2: [4, 1000],
  },
  {
    id: 101,
    name: "The Ashes 2025-26",
    link: "/cricket/ashes",
    time: "In-Play",
    icons: ["F", "S", "BM"],
    odds1: [1.1, 1.11],
    oddsX: [110, 140],
    odds2: [10.5, 11],
  },
  {
    id: 102,
    name: "Test Match - India v South Africa",
    link: "/cricket/test-match",
    time: "09-11-2025 8:10",
    icons: ["F", "BM"],
    odds1: [2.14, 6],
    oddsX: [2.48, 1000],
    odds2: [4, 1000],
  },
  {
    id: 101,
    name: "India v South Africa",
    link: "cricket/south-africa",
    time: "In-Play",
    icons: ["F", "S", "BM"],
    odds1: [1.1, 1.11],
    oddsX: [110, 140],
    odds2: [10.5, 11],
  },
  {
    id: 102,
    name: "Abu Dhabi T10 League",
    link: "/cricket/abudhabi",
    time: "09-11-2025 8:10",
    icons: ["F", "BM"],
    odds1: [2.14, 6],
    oddsX: [2.48, 1000],
    odds2: [4, 1000],
  },
  {
    id: 101,
    name: "Nepal Pre League",
    link: "/cricket/nepal-pre-league",
    time: "In-Play",
    icons: ["F", "S", "BM"],
    odds1: [1.1, 1.11],
    oddsX: [110, 140],
    odds2: [10.5, 11],
  },
  {
    id: 102,
    name: "International Matches",
    link: "/cricket/international",
    time: "09-11-2025 8:10",
    icons: ["F", "BM"],
    odds1: [2.14, 6],
    oddsX: [2.48, 1000],
    odds2: [4, 1000],
  },
  {
    id: 101,
    name: "India v South Africa",
    link: "In-Play",
    time: "In-Play",
    icons: ["F", "S", "BM"],
    odds1: [1.1, 1.11],
    oddsX: [110, 140],
    odds2: [10.5, 11],
  },
  {
    id: 102,
    name: "WBBL – Winner 2025",
    link: "",
    time: "09-11-2025 8:10",
    icons: ["F", "BM"],
    odds1: [2.14, 6],
    oddsX: [2.48, 1000],
    odds2: [4, 1000],
  },
  {
    id: 101,
    name: "India v South Africa",
    link: "In-Play",
    time: "In-Play",
    icons: ["F", "S", "BM"],
    odds1: [1.1, 1.11],
    oddsX: [110, 140],
    odds2: [10.5, 11],
  },
  {
    id: 102,
    name: "WBBL – Winner 2025",
    link: "",
    time: "09-11-2025 8:10",
    icons: ["F", "BM"],
    odds1: [2.14, 6],
    oddsX: [2.48, 1000],
    odds2: [4, 1000],
  },
  {
    id: 101,
    name: "India v South Africa",
    link: "In-Play",
    time: "In-Play",
    icons: ["F", "S", "BM"],
    odds1: [1.1, 1.11],
    oddsX: [110, 140],
    odds2: [10.5, 11],
  },
  {
    id: 102,
    name: "WBBL – Winner 2025",
    link: "",
    time: "09-11-2025 8:10",
    icons: ["F", "BM"],
    odds1: [2.14, 6],
    oddsX: [2.48, 1000],
    odds2: [4, 1000],
  },
];
